// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2ltNV","content":"GlobalSearch_content__QjNSz"};